export const GET_ERRORS = "GET_ERRORS";
export const REMOVE_CURRENT_USER = "REMOVE_CURRENT_USER";
export const SET_CURRENT_USER = "SET_CURRENT_USER";